import { Flex, Tag, Skeleton } from 'antd';
import React from 'react';
import { getProgramTypes } from 'components/organisms/oneplatform/patient-readings/patientReadingsUtils';

import s from './styles.module.scss';

import type { CcmStatuses, RpmStatuses } from 'infrastructure/enums';

interface ProgramTypeProps {
  rpmStatus?: RpmStatuses;
  ccmStatus?: CcmStatuses;
  isLoading?: boolean;
}

const ProgramType: React.FC<ProgramTypeProps> = ({
  rpmStatus,
  ccmStatus,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <Flex gap={6}>
        <Skeleton.Node active className={s['skeleton-tag']} />
        <Skeleton.Node active className={s['skeleton-tag']} />
      </Flex>
    );
  }

  if (!rpmStatus && !ccmStatus) {
    return null;
  }

  const programTypes = getProgramTypes(rpmStatus, ccmStatus);
  return (
    <Flex gap={6}>
      {programTypes?.map((type) => (
        <Tag
          color={type === 'RPM' ? 'orange' : 'blue'}
          key={type}
          className={s['type-tag']}
        >
          {type}
        </Tag>
      ))}
    </Flex>
  );
};

export default ProgramType;
